import { Analytics, TokenResolver } from '@envoy/react-rich-components-core';

export type EnvironmentType = 'production' | 'staging' | 'dev';
export type ServiceType = keyof ServiceUrls;

export interface ServiceUrls {
  envoyWeb: string;
  federatedGraphQL: string;
}

const serviceUrls: Record<EnvironmentType, ServiceUrls> = {
  production: {
    envoyWeb: 'https://app.envoy.com/',
    federatedGraphQL: 'https://envoy-graphql-gateway.envoy.com/',
  },
  staging: {
    envoyWeb: 'https://app.envoy.christmas/',
    federatedGraphQL: 'https://envoy-graphql-gateway.envoy.christmas/',
  },
  dev: {
    envoyWeb: 'https://app.envoy.dev/',
    federatedGraphQL: 'https://dashboard.envoy.dev/a/graphql_federated',
  },
};

export class ReactRichComponentsConfig {
  tokenResolver?: TokenResolver;
  analytics?: Analytics;

  serviceUrls: ServiceUrls = {
    ...serviceUrls.production,
  };

  setEnvironment(type: EnvironmentType) {
    this.serviceUrls = { ...serviceUrls[type] };
  }
}

export const reactRichComponentsConfig = new ReactRichComponentsConfig();
